import { render, staticRenderFns } from "./systemicDetails.vue?vue&type=template&id=632d4da2"
import script from "./systemicDetails.vue?vue&type=script&lang=js"
export * from "./systemicDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports